import React from "react";
import { PlanoModal, PlanoTypography } from "../../Common";

const GuidelinesModalContent = ({ heading, content }) => {
  return (
    <PlanoTypography>
      <span
        style={{
          fontWeight: 800,
          fontSize: "16px",
        }}
      >
        {heading}
      </span>{" "}
      <br />
      {content}
    </PlanoTypography>
  );
};
const DashboardGuidelinesModal = ({ open, setOpen }) => {
  return (
    <PlanoModal open={open} setOpen={setOpen} title={"Guidelines"}>
      <GuidelinesModalContent
        heading={"1. Familiarize Yourself:"}
        content={
          "Understand the planogram layout, including product placement and facing instructions."
        }
      />
      <GuidelinesModalContent
        heading={"2. Refer to Visual Guides:"}
        content={
          "Use visual aids and posters in your section to quickly grasp the planogram details."
        }
      />
      <GuidelinesModalContent
        heading={"3. Follow Checklists:"}
        content={
          "Utilize provided checklists during shelf checks and restocking to ensure planogram compliance."
        }
      />
      <GuidelinesModalContent
        heading={"4. Collaborate with Team:"}
        content={
          "Work collaboratively with team members to collectively maintain a well-organized store."
        }
      />
      <GuidelinesModalContent
        heading={"5. Adapt to Customer Needs:"}
        content={"Be mindful of customer prefere"}
      />
    </PlanoModal>
  );
};

export default DashboardGuidelinesModal;
